import { h } from "vue";

export default [
  {
    path: "/padAdmin/company",
    name: "PadAdminCompany",
    meta: {
      title: "数智健康管理系统",
      keepAlive: false,
      auth: true,
      home: false,
      footer: true,
      header: true,
    },
    component: () => import("@views/padAdmin/company.vue"),
  },
  {
    path: "/padAdmin/person",
    name: "PadAdminPerson",
    meta: {
      title: "数智健康管理系统",
      keepAlive: false,
      auth: true,
      home: false,
      footer: true,
      header: true,
    },
    component: () => import("@views/padAdmin/addPerson.vue"),
  },
];
